// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"53cea45cf00b8b94","3056":"567d5be95c9ad14a"}[chunkId] + ".css";
};